// @Angular
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouteReuseStrategy, RouterModule } from '@angular/router';

// Third party
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

// Local modules
import { SharedModule } from '@app/shared/shared.module';

// Local services
import { AuthenticationService } from './authentication/authentication.service';
import { AuthenticationGuard } from './authentication/authentication.guard';
import { PermissionsGuard } from './authentication/permissions.guard';
import { I18nService } from './utilities/i18n.service';
import { HttpService } from './http/http.service';
import { HttpCacheService } from './http/http-cache.service';
import { ErrorHandlerInterceptor } from './http/error-handler.interceptor';
import { CacheInterceptor } from './http/cache.interceptor';
import { AuthInterceptor } from './http/auth.interceptor';

import { EndpointService } from './http/endpoint.service';
import { HttpErrorHandlingService } from './http/http-error-handling.service';
import { GlobalInfoService } from './utilities/global-info.service';
import { GlobalNotifierService } from './utilities/global-notifier.service';

// Local components
import { ShellComponent } from './shell/shell.component';
import { HeaderComponent } from './shell/header/header.component';
import { SidebarComponent } from './shell/sidebar/sidebar.component';

// Others
import { RouteReusableStrategy } from './utilities/route-reusable-strategy';
import { ReportsModule } from '@app/reports';
import { ErrorHandlerPermissionsInterceptor } from './http/error-handler-permissions.interceptor';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    SharedModule,
    TranslateModule,
    CollapseModule,
    CollapseModule,
    BsDropdownModule,
    FlexLayoutModule,
    RouterModule,
    ReportsModule
  ],
  declarations: [HeaderComponent, ShellComponent, SidebarComponent],
  providers: [
    AuthenticationService,
    AuthenticationGuard,
    PermissionsGuard,
    I18nService,
    EndpointService,
    HttpErrorHandlingService,
    GlobalInfoService,
    GlobalNotifierService,
    HttpCacheService,
    ErrorHandlerInterceptor,
    ErrorHandlerPermissionsInterceptor,
    CacheInterceptor,
    {
      provide: HttpClient,
      useClass: HttpService
    },
    {
      provide: RouteReuseStrategy,
      useClass: RouteReusableStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    // Import guard
    if (parentModule) {
      throw new Error(`${parentModule} has already been loaded. Import Core module in the AppModule only.`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts